var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blue-header",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 306,
    viewBox: "0 0 1920 306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17340",
    "data-name": "Rectangle 17340",
    width: 490,
    height: 306,
    transform: "translate(0)",
    fill: "#fff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    width: 1920,
    height: 305,
    transform: "translate(0 1)",
    fill: "#0087ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ovals",
    transform: "translate(146 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(1579 18)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_Copy",
    "data-name": "Oval Copy",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(47)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_Copy_2",
    "data-name": "Oval Copy 2",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(1620 57)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_Copy_3",
    "data-name": "Oval Copy 3",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(0 40)",
    fill: "#fff",
    opacity: 0.24,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangles",
    transform: "translate(203.172 238.353)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy",
    "data-name": "Rectangle Copy",
    width: 13,
    height: 13,
    rx: 2,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 3.365)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4,
    opacity: 0.478,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HeaderBacker",
    transform: "translate(1430)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_31",
    "data-name": "Mask Group 31",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M3100.856,1095l-370.213,981.89,539.625-3.537.6-978.353Z",
    transform: "translate(-2781.47 -1236.231)",
    fill: "#fff",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M3360.225,1095h-36.946L2540.8,2073.353h819.426Z",
    transform: "translate(-2870.226 -1236.231)",
    fill: "#fff",
    opacity: 0.08
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueHeader);
export default __webpack_public_path__ + "static/media/blue-header.af3bb3315ee2cc9e5fd54b8709a40d9c.svg";
export { ForwardRef as ReactComponent };